<template>
  <base-section
    id="customer-reviews"
    class="grey lighten-5"
    space="64"
  >
    <base-section-heading
      icon=""
      space="0"
      title="In Memory of"
    />
    <v-carousel
      class="mt-n12"
      height="640"
      light
      hide-delimiters="true"
      :show-arrows="false"
    >
      <v-carousel-item
        v-for="(customer, i) in customers"
        :key="i"
      >
        <v-container class="fill-height">
          <v-responsive
            class="mx-auto shrink text-center"
            max-width="90%"
            width="700"
          >
            <base-body
              v-if="customer.review.length>0"
              :text="customer.review"
              tag="em"
              class="mb-3 d-block"
            />

            <v-avatar
              class="mb-2"
              size="144"
            >
              <base-img :src="require(`@/assets/user-${i + 1}.jpg`)" />
            </v-avatar>

            <base-title
              :title="customer.name"
              space="0"
            />

            <base-subtitle :title="customer.role" />

            <v-container fluid>
              <v-row>
                <v-col
                  v-for="card in cards"
                  :key="card.title"
                  cols="12"
                  sm="12"
                  md="12"
                >
                  <base-info-card
                    align="center"
                    dark
                    v-bind="card"
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-responsive>
        </v-container>
      </v-carousel-item>
    </v-carousel>

    <span class="trace">InMemory.vue</span>
  </base-section>
</template>

<script>
  export default {
    name: 'SectionCustomerReviews',

    provide: {
      heading: { align: 'center' },
    },

    data: () => ({
      customers: [
        {
          review: '',
          name: 'John Hopkins',
          role: 'Truro Environmental Activist',
        },
        {
          review: '',
          name: 'Maureen Burgess',
          role: 'Truro Environmental Activist',
        },

        /*
        {
          review: '"Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quisquam aspernatur, sint recusandae cum temporibus quos saepe repellendus consectetur et reprehenderit. Ratione ipsam consequuntur quo eligendi mollitia veniam facere possimus inventore."',
          name: 'HENRY LUSIO',
          role: 'DIRECTOR OF EXAMPLE LTD',
        },
        {
          review: '"Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quisquam aspernatur, sint recusandae cum temporibus quos saepe repellendus consectetur et reprehenderit. Ratione ipsam consequuntur quo eligendi mollitia veniam facere possimus inventore."',
          name: 'HENRY LUSIO',
          role: 'DIRECTOR OF EXAMPLE LTD',
        },
        */
      ],

      cards: [
        {
          icon: '',
          title: 'Truro Committees',
          text: '',
          html: '<a href="https://provincetown.wickedlocal.com/news/20200510/truro-vietnam-vet-activist-john-hopkins-dies-in-costa-rica" target="_page2">Truro Vietnam vet, climate activist John Hopkins dies in Costa Rica</a><br><a href="https://provincetownindependent.org/news/2020/04/30/john-hopkins-dies-in-costa-rica/" target="_page2">John Hopkins Dies in Costa Rica, April 23, 2020</a>',
        },
      ],

    }),
  }
</script>

<style lang="sass">
  #customer-reviews
    .v-carousel__controls
      background: transparent

    .base-body
      line-height: 2
</style>
